import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CommentsEmptyState from '../CommentsEmptyState';
import CommentBox from '../CommentsBox';
import FileComments from '../FileComments';
import CollborationGroupError from '../CollborationGroupError';
import RevisionRequest from '../RevisionRequest';
import PreRevisionWizard from '../PreRevisionWizard';
import { commentEventsBus, COMMENT_ADDED_EVENT, REPLY_CLICKED } from '../../eventsBus/comment';
import { MARKER_CLICK_EVENT, ANNOTATION_CLICK_EVENT } from '../../../MediaViewer/consts';
import { EXTERNAL_GROUP_NAME, collaborationEventBus } from '../../../Utils';
import * as GroupsSelectors from '../../selectors/groups';
import * as CommentsSelectors from '../../selectors/comments';
import * as CollaboratorsSelectors from '../../selectors/collaborators';
import * as Selectors from '../../selectors';
import * as CurrentsSelectors from '../../selectors/current';
import * as SettingsSelectors from '../../selectors/settings';
import './style.scss';

class CommentsList extends Component {

    constructor() {
        super();

        this.state = {
            showNoComments: true
        };

        this.scrollIdIntoView = this.scrollIdIntoView.bind(this);
        this.setShowNoCommentsTrue = this.setShowNoCommentsTrue.bind(this);
        this.setShowNoCommentsFalse = this.setShowNoCommentsFalse.bind(this);
    }

    componentDidMount() {
        commentEventsBus.on(COMMENT_ADDED_EVENT,
            (id) => this.scrollIdIntoView(id)
        );
        commentEventsBus.on(REPLY_CLICKED,
            (id) => this.scrollIdIntoView(id)
        );

        collaborationEventBus.on(MARKER_CLICK_EVENT,
            ({ id }) => this.scrollIdIntoView(id, true)
        );
        collaborationEventBus.on(ANNOTATION_CLICK_EVENT,
            ({ commentId }) => this.scrollIdIntoView(commentId, true)
        );
    }

    componentDidUpdate(prevProps) {
        const {
            currentFileId,
            placeholderTabClicked,
            groupType
        } = this.props;

        if (prevProps.currentFileId !== currentFileId || prevProps.placeholderTabClicked !== placeholderTabClicked || prevProps.groupType !== groupType) {
            this.setShowNoCommentsTrue();
        }

        if (prevProps.currentFileId !== currentFileId) {
            this.scrollIdIntoView(currentFileId, true, true);
        }
    }

    scrollIdIntoView(id, alignTop = false, file) {
        setTimeout(() => {
            if (this.olRoot) {
                const commentElement = file ? this.olRoot.querySelector(`#file-comment-${id}`) : this.olRoot.querySelector(`#comment-${id}`);
                commentElement && commentElement.scrollIntoView(alignTop);
            }
        }, 0);
    }

    setShowNoCommentsTrue() {
        this.setState({
            showNoComments: true
        });
    }

    setShowNoCommentsFalse() {
        this.setState({
            showNoComments: false
        });
    }

    render() {
        const {
            commentIds,
            isCollaborationDataReady,
            fileIds,
            placeholderTabClicked,
            groupType,
            currentCollaboratorInvitePermissions,
            isCurrentCollaboratorExternal,
            currentFileId,
            onlyOneGroup,
            isPostRevisionMode,
            isPreRevisionMode,
            isSellerCollaborationTabSelected
        } = this.props;

        const { showNoComments } = this.state;

        if (placeholderTabClicked && currentCollaboratorInvitePermissions && onlyOneGroup) {
            return (
                <div className="comments-list-wrapper">
                    <CommentsEmptyState placeholderTabClicked={placeholderTabClicked}/>
                </div>
            );
        }

        if (!isCollaborationDataReady) {
            return (
                <div className="comments-list-wrapper">
                    <CollborationGroupError/>
                </div>
            );
        }

        if (isPreRevisionMode && !placeholderTabClicked && isSellerCollaborationTabSelected) {
            return (
                <PreRevisionWizard/>
            );
        }

        if (isPostRevisionMode && groupType !== EXTERNAL_GROUP_NAME) {
            return (
                <div className="comments-list-wrapper revision">
                    <div className="comments-list">
                        <RevisionRequest/>
                        <ol ref={(ref) => this.olRoot = ref}>
                            {fileIds.map((fileId) => (
                                <FileComments key={fileId} fileId={fileId}/>
                            ))}
                        </ol>
                    </div>
                    <CommentBox/>
                </div>
            );
        }

        if (!commentIds || !commentIds.length) {
            const emptyStateNoExternalUser = !isCurrentCollaboratorExternal && groupType === EXTERNAL_GROUP_NAME;
            return (
                <div className="comments-list-wrapper">
                    {fileIds.map((fileId) => (
                        <FileComments key={fileId} fileId={fileId}/>
                    ))}
                    <CommentBox setShowNoCommentsTrue={this.setShowNoCommentsTrue} setShowNoCommentsFalse={this.setShowNoCommentsFalse}/>
                    {showNoComments && <CommentsEmptyState collaboratorTab={emptyStateNoExternalUser}/>}
                </div>
            );
        }

        if (isPostRevisionMode && groupType !== EXTERNAL_GROUP_NAME) {
            return (
                <div className="comments-list-wrapper revision">
                    <div className="comments-list">
                        <RevisionRequest/>
                        <ol ref={(ref) => this.olRoot = ref}>
                            {fileIds.map((fileId) => (
                                <FileComments key={fileId} fileId={fileId}/>
                            ))}
                        </ol>
                    </div>
                    <CommentBox/>
                </div>
            );
        }

        return (
            <div className="comments-list-wrapper">
                <ol className="comments-list" ref={(ref) => this.olRoot = ref}>
                    {fileIds.map((fileId) =>
                        [
                            <FileComments key={fileId} fileId={fileId}/>,
                            currentFileId === fileId ? <CommentBox/> : null
                        ]
                    )}
                </ol>
            </div>
        );
    }
}

CommentsList.defaultProps = {
    commentsIds: [],
    fileIds: [],
    groupType: 'seller',
    isCollaborationDataReady: false,
    placeholderTabClicked: false,
    currentCollaboratorInvitePermissions: false,
    onlyOneGroup: true,
    isPostRevisionMode: false
};

CommentsList.propTypes = {
    commentIds: PropTypes.array,
    fileIds: PropTypes.array,
    groupType: PropTypes.string,
    isCollaborationDataReady: PropTypes.bool,
    placeholderTabClicked: PropTypes.bool,
    currentCollaboratorInvitePermissions: PropTypes.bool,
    isCurrentCollaboratorExternal: PropTypes.bool,
    currentFileId: PropTypes.string,
    onlyOneGroup: PropTypes.bool,
    isPostRevisionMode: PropTypes.bool,
    isPreRevisionMode: PropTypes.bool,
    isSellerCollaborationTabSelected: PropTypes.bool
};

function mapStateToProps(state) {
    const { id, type } = GroupsSelectors.getCurrentGroup(state);

    return {
        commentIds: CommentsSelectors.getCommentIdsByCurrentGroupId(state),
        isCollaborationDataReady: Selectors.isCollaborationDataReady(state),
        currentCollaboratorInvitePermissions: CollaboratorsSelectors.getCurrentCollaboratorInvitePermissions(state),
        fileIds: GroupsSelectors.getFileIdsByGroupId(state, id),
        groupType: type,
        isCurrentCollaboratorExternal: CollaboratorsSelectors.isCurrentCollaboratorExternal(state),
        currentFileId: CurrentsSelectors.getCurrentFileId(state),
        onlyOneGroup: GroupsSelectors.isSingle(state),
        isPostRevisionMode: SettingsSelectors.isPostRevisionBehavior(state),
        isSellerCollaborationTabSelected: GroupsSelectors.isSellerCollaborationTabSelected(state),
        isPreRevisionMode: SettingsSelectors.isPreRevisionBehavior(state)
    };
}

export default connect(mapStateToProps)(CommentsList);
